/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface SpeciesReading
 */
export interface SpeciesReading {
    /**
     * 
     */
    scientific: string | null;
    /**
     * 
     */
    common: string | null;
    /**
     * 
     */
    estimateScientific: string | null;
    /**
     * 
     */
    estimateCommon: string | null;
    /**
     * 
     */
    source: SpeciesReadingSourceEnum;
    /**
     * 
     */
    correctionId: string | null;
    /**
     * 
     */
    at: Date | null;
}


/**
 * @export
 */
export const SpeciesReadingSourceEnum = {
    Estimate: 'estimate',
    Text: 'text',
    Form: 'form',
} as const;
export type SpeciesReadingSourceEnum = typeof SpeciesReadingSourceEnum[keyof typeof SpeciesReadingSourceEnum];


/**
 * Check if a given object implements the SpeciesReading interface.
 */
export function instanceOfSpeciesReading(value: object): value is SpeciesReading {
    if (!('scientific' in value) || value['scientific'] === undefined) return false;
    if (!('common' in value) || value['common'] === undefined) return false;
    if ((!('estimateScientific' in (value as Record<string, any>)) && !('estimate_scientific' in (value as Record<string, any>))) || ((value as Record<string, any>)['estimateScientific'] === undefined && (value as Record<string, any>)['estimate_scientific'] === undefined)) return false;
    if ((!('estimateCommon' in (value as Record<string, any>)) && !('estimate_common' in (value as Record<string, any>))) || ((value as Record<string, any>)['estimateCommon'] === undefined && (value as Record<string, any>)['estimate_common'] === undefined)) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if ((!('correctionId' in (value as Record<string, any>)) && !('correction_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['correctionId'] === undefined && (value as Record<string, any>)['correction_id'] === undefined)) return false;
    if (!('at' in value) || value['at'] === undefined) return false;
    return true;
}

export function SpeciesReadingFromJSON(json: any): SpeciesReading {
    return SpeciesReadingFromJSONTyped(json, false);
}

export function SpeciesReadingFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpeciesReading {
    if (json == null) {
        return json;
    }
    return {
        
        'scientific': json['scientific'],
        'common': json['common'],
        'estimateScientific': json['estimate_scientific'],
        'estimateCommon': json['estimate_common'],
        'source': json['source'],
        'correctionId': json['correction_id'],
        'at': (json['at'] == null ? null : parseDateTime(json['at'])),
    };
}

export function SpeciesReadingToJSON(json: any): SpeciesReading {
    return SpeciesReadingToJSONTyped(json, false);
}

export function SpeciesReadingToJSONTyped(value?: SpeciesReading | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'scientific': value['scientific'],
        'common': value['common'],
        'estimate_scientific': value['estimateScientific'],
        'estimate_common': value['estimateCommon'],
        'source': value['source'],
        'correction_id': value['correctionId'],
        'at': value['at'] == null ? value['at'] : serializeDateTime(value['at']),
    };
}

